import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25 4.688A20.313 20.313 0 1 0 45.313 25 20.334 20.334 0 0 0 25 4.688m7.355 25.457a1.564 1.564 0 0 1-2.21 2.21L25 27.21l-5.145 5.147a1.565 1.565 0 0 1-2.55-.508 1.565 1.565 0 0 1 .34-1.703L22.79 25l-5.146-5.145a1.564 1.564 0 0 1 2.21-2.21L25 22.79l5.145-5.146a1.566 1.566 0 0 1 2.21 0 1.564 1.564 0 0 1 0 2.21L27.21 25z"
    }, null, -1)
  ])))
}
export default { render: render }